export const POST_EMPLOYEE_SEARCH_KEY = 'EmployeeSearch';
